<template>
  <div class="fb-container">
    <div v-if="title.length > 0" class="flex-row-nowrap-start-center-center fb-title-container" :style="titleStyle">
      <div v-if="showBar" class="fb-bar"></div>
      <div class="fb-title flex-row-nowrap-start-start-center">{{ title }}</div>
      <slot name="action"></slot>
    </div>
    <div class="flex-col-nowrap-start-start-start fb-content">
      <slot></slot>
    </div>
  </div>
</template>
<script lang="ts" setup>
import { computed, reactive, ref } from "vue"

const props = withDefaults(
  defineProps<{
    title?: string
    titleWidth?: number
    titleMargin?: number
    showBar?: boolean
  }>(),
  {
    title: "",
    titleMargin: 24,
    showBar: true,
  }
)

const titleStyle = computed(() => {
  if (props.titleWidth) {
    return {
      width: `${props.titleWidth}px`,
      "margin-bottom": `${props.titleMargin}px`,
    }
  } else {
    return {
      width: "100%",
      "margin-bottom": `${props.titleMargin}px`,
    }
  }
})
</script>
<style scoped>
.fb-bar {
  width: 4px;
  height: 14px;
  background-color: #48b02c;
  border-radius: 2px;
  margin-right: 8px;
  flex-shrink: 0;
}

.fb-container {
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding-bottom: 32px;
}
.fb-title-container {
}
.fb-title {
  min-height: 34px;
  font-size: 14px;
  color: #333;
  font-weight: 500;
  flex-grow: 1;
}

.fb-content {
  width: 100%; /* 确保内容区域宽度为100%，以便上方的div可以与其对齐 */
}

.fb-content > *:not(:last-child) {
  margin-bottom: 16px;
}
</style>
